<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="objektasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Registro objektas"
                  v-model="extraData.aut_tipas"
                  @change="objektasChange()"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="veiksmasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Veiksmas"
                  :readonly="!enableVeiksmas"
                  v-model="extraData.aut_veiksmas"
                  @change="veiksmasChange()"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="registravimasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Registravimas"
                  v-model="extraData.aut_automatinis"
                />
              </v-col>

              <v-col cols="12" md="6">
                <el-date-picker
                  label="Pakeitimo data nuo"
                  v-model="extraData.aut_atnaujinimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Pakeitimo data iki"
                  v-model="extraData.aut_atnaujinimo_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  Ieškoti
                </el-button>
                <el-button @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminRegistravimasAutomatuSearch',
  props: {
    loading: Boolean,
    ntrpaslaugos: Boolean,
  },
  data: () => ({
    auto_registravimas_objektas: [],
    auto_registravimas_veiksmas: [],
    auto_registravimas_objektas_nep: [],
    auto_registravimas_veiksmas_nep: [],
    registravimasList: [
      {
        text: 'Automatinis',
        value: true,
      },
      {
        text: 'Rankinis',
        value: false,
      },
    ],
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      aut_tipas: null,
      aut_veiksmas: null,
    },
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    objektasList() {
      if (this.ntrpaslaugos) {
        return this.auto_registravimas_objektas_nep
      }
      return this.auto_registravimas_objektas
    },
    veiksmasList() {
      if (this.ntrpaslaugos) {
        return this.auto_registravimas_veiksmas_nep.filter(item => {
          return item.value.includes(this.extraData.aut_tipas)
        })
      }
      return this.auto_registravimas_veiksmas.filter(item => {
        return item.value.includes(this.extraData.aut_tipas)
      })
    },
    enableVeiksmas() {
      return this.extraData.aut_tipas
    },
  },
  watch: {
    ntrpaslaugos(val) {
      this.extraData.aut_tipas = null
      this.extraData.aut_veiksmas = null
      this.searchData()
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: [
          'auto_registravimas_objektas',
          'auto_registravimas_veiksmas',
          'auto_registravimas_objektas_nep',
          'auto_registravimas_veiksmas_nep',
        ],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.auto_registravimas_objektas =
            res.data.list.auto_registravimas_objektas
          this.auto_registravimas_veiksmas =
            res.data.list.auto_registravimas_veiksmas
          this.auto_registravimas_objektas_nep =
            res.data.list.auto_registravimas_objektas_nep
          this.auto_registravimas_veiksmas_nep =
            res.data.list.auto_registravimas_veiksmas_nep

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {}
    },
    submit() {
      this.searchData()
    },
    objektasChange() {
      this.extraData.aut_veiksmas = null
    },
    veiksmasChange() {
      //
    },
  },
}
</script>
